import { account1 } from '../services/bankAccountData';

export const setEmailBodyConfirm = (props) => {
    const { formValues, eventValues, src } = props;
    // console.log(formValues, eventValues, src);
    const styles = {
        p: { border: "1px solid gray", width: "380px", backgroundColor: "#ddd" },
        div: {
            border: "1px solid gray",
            width: "380px",
            padding: "0 20px",
            margin: "10px 6px",
            backgroundColor: "#ddd",
        },
        divWhite: {
            textAlign: "center",
            width: "380px",
            padding: "0 20px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        divWhiteNoMargin: {
            textAlign: "center",
            width: "380px",
            padding: "0 20px",
            backgroundColor: "#fff",
        },
        divWhiteNoPadding: {
            textAlign: "center",
            width: "380px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        divWhiteLeft: {
            border: "1px solid gray",
            width: "380px",
            padding: "0 20px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        divWhiteLeftNoBorder: {
            width: "380px",
            padding: "10px 20px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        li: { padding: "6px 0" },
    };

    let datosParaPago = '';
    // Si se paga
    if (formValues.claveProyecto !== '0') {
        console.log(formValues.claveProyecto);
        switch (formValues.claveProyecto) {
            // Evento SIMAC
            case '74622':
                datosParaPago =
                    <div style={styles.divWhiteLeft}>
                        <h3>Indicaciones para completar el registro</h3>
                        <ul>
                            <li style={styles.li}>Pagar en sucursal bancaria la cuota correspondiente. Únicamente se aceptan transferencias bancarias y depósitos bancarios.
                                <p>
                                    Banco: <strong>BBVA</strong><br />
                                    Nombre: <strong>Sociedad Ictiológica Mexicana A.C.</strong><br />
                                    Número de cuenta: <strong>0119427406</strong><br />
                                    CLABE interbancaria: <strong>012040001194274061</strong><br />
                                    Sucursal: <strong>5313 La Paz</strong><br />
                                    Concepto: <strong> Nombre del participante y referencia ({formValues.registroReferencia})</strong><br />
                                </p>
                            </li>
                            <li style={styles.li}>Subir al sistema su comprobante de deposito:<br/>
                                <h4><a href={eventValues.urlConfirma}>Enlace para subir su comprobante</a></h4>
                            </li>
                            <li style={styles.li}>En caso de requerir factura, deberá terminar su registro a más tardar una semana posterior a su pago para poder realizar dicho trámite.
                            </li>
                            <li style={styles.li}>Toda factura tendrá como concepto: Gastos en general.
                            </li>
                        </ul>
                    </div>;
                break;
        
            default:
                datosParaPago =
                    <div style={styles.divWhiteLeft}>
                        <h3>Indicaciones para completar el registro</h3>
                        <ul>
                            <li style={styles.li}>Pagar en sucursal bancaria la cuota correspondiente o,
                            </li>
                            <li>
                                Pagar por medio de su aplicación bancaria, en modalidad pago de servicios o,
                            </li>
                            <li>
                                Pagar directamente en caja del CIBNOR, horario de 9 a 14 horas en días hábiles.
                                <p>
                                    Banco: <strong>{ account1.nombre }</strong><br />
                                    Convenio CIE: <strong>{ account1.convenio }</strong> <br />
                                    {/* Banco: <strong>BBVA</strong><br />
                                    Convenio CIE: <strong>1 2 5 6 2 5</strong> <br /> */}
                                    Referencia: <strong>{ formValues.registroReferencia }</strong><br />
                                </p>
                            </li>
                            <li style={styles.li}>Subir al sistema su comprobante de deposito:<br/>
                                <h3><a href={eventValues.urlConfirma}>Enlace para subir su comprobante</a></h3>
                            </li>
                            <li style={styles.li}>
                                <strong>Después de realizar el pago cuenta con un máximo de 5 días hábiles para completar su registro, en caso contrario este será anulado.</strong>
                            </li>
                            <li style={styles.li}>En caso de solicitar factura, ésta se enviará al correo que se ingresó.
                            </li>
                            <li style={styles.li}>Se realizará la facturación salvo buen cobro.
                            </li>
                        </ul>
                        <p>
                            Después de realizar el pago cuenta con un máximo de 5 días hábiles para completar su registro, en caso contrario este será anulado.
                        </p>
                    </div>;
                break;
        }
    }


    // registroReferencia

    return (
        <>
            {/* Logo */}
            <div style={styles.divWhite}>
                <img src={eventValues.urlLogo} alt="logo" width={120} />
            </div>
            {/* Titulo */}
            <div style={styles.divWhite}>
                <h2>{eventValues.title}</h2>
            </div>
            {/* Numero de referencia */}
            <div style={styles.divWhite}>
                <h3>¡Su registro inicial ha sido completado con éxito!</h3>
                <h2>
                    {formValues.partNombres} {formValues.partApellidoPaterno} {formValues.partApellidoMaterno}
                </h2>
                <h3>Numero de referencia:</h3>
                <h2>{formValues.registroReferencia}</h2>
            </div>
            {/* Procedimiento de pago */}
            { datosParaPago }

            {/* Datos adicionales */}
            <div style={styles.divWhiteLeft}>
                <div dangerouslySetInnerHTML={{ __html: eventValues.aditionalData }} />
            </div>
            {/* Footer */}
            <div style={styles.divWhiteLeftNoBorder}>
                <strong>
                    <i>
                        Atentamente,
                        <br />
                        Comité organizador
                    </i>
                </strong>
            </div>
            {/* QR */}
            { src ? 
            <div style={styles.divWhite}>
                <img src={ src.qrdata } alt="QR" width={200} />
            </div>
            : '' }
            
        </>
    );
};
